<template>
  <BaseLayout>
    <div class="row">
      <div class="col-xl-8">
        <Wizard />

        <slot />
      </div>

      <div class="col-xl-4">
        <OrderSummaryWidget>
          <template #footerBtns>
            <NavigateToSteps
              :disable-next-btn="disableNextBtn"
              @next="$emit('next')"
            />
          </template>
        </OrderSummaryWidget>
      </div>
    </div>
  </BaseLayout>
</template>
<script>
import BaseLayout from "@/layouts/BaseLayout.vue";
import Wizard from "@/components/Wizard.vue";
import OrderSummaryWidget from "@/views/Orders/Create/-OrderSummaryWidget.vue";
import NavigateToSteps from "@/views/Orders/Create/-NavigateToSteps.vue";

export default {
  components: {
    BaseLayout,
    Wizard,
    OrderSummaryWidget,
    NavigateToSteps,
  },
  props: {
    disableNextBtn: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
